import * as e from "react";
import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
const r = /* @__PURE__ */ e.createContext();
function u({
  value: t,
  ...o
}) {
  return /* @__PURE__ */ s.jsx(r.Provider, {
    value: t ?? !0,
    ...o
  });
}
const a = () => e.useContext(r) ?? !1;
export {
  u as R,
  a as u
};
//# sourceMappingURL=index-CLU0MTzP.mjs.map
